import React, { Component } from 'react';
import $ from 'jquery';
import * as Reqst from '../../utils/Reqst';
import Sanitize from '../../utils/Sanitize';
import {Row,Col} from 'react-bootstrap';

import PageTitle from '../../containers/PageTitle';

class Dashboard extends Component{
	constructor(props){
		super(props);
		this.state = {
			loginText: 'LOGIN',
			isRedirect: false,
		}
		
	}
	
	componentDidMount(){
		
	}
	
	render(){
	
		return(
			<div>
				<PageTitle title="Dashboard" ></PageTitle>
			</div>
		);
	}
	
}
export default Dashboard;